export const formatTime = (seconds: number) => {
  const hrs = Math.floor(seconds / 3600);
  const mins = Math.floor((seconds % 3600) / 60);
  const secs = Math.floor(seconds % 60);

  if (hrs > 0) {
    return `${String(hrs).padStart(2, '0')}:${String(mins).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
  }

  return `${String(mins).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
};

export const formatDurationWithLabels = (totalSeconds?: string | number | null) => {
  if (!totalSeconds) { return '-'; }
  const seconds = typeof totalSeconds === 'string' ? Number.parseInt(totalSeconds, 10) : totalSeconds;
  if (Number.isNaN(seconds)) { return '-'; }

  const hrs = Math.floor(seconds / 3600);
  const mins = Math.floor((seconds % 3600) / 60);
  const secs = Math.floor(seconds % 60);

  const parts = [];
  if (hrs > 0) { parts.push(`${hrs}hr`); }
  if (mins > 0 || hrs > 0) { parts.push(`${mins}mins`); }
  parts.push(`${secs}sec`);

  return parts.join(' ');
};

export const formatTimeMs = (milliseconds: number) => {
  return formatTime(milliseconds / 1000);
};

export const formatDurationWithLabelsMs = (totalMilliseconds?: string | number | null) => {
  if (!totalMilliseconds) { return '-'; }
  const milliseconds = typeof totalMilliseconds === 'string' ? Number.parseInt(totalMilliseconds, 10) : totalMilliseconds;
  if (Number.isNaN(milliseconds)) { return '-'; }

  return formatDurationWithLabels(milliseconds / 1000);
};